import React from 'react';
import './AboutUs.css';

const OurNewsLetter = () => {
  return (
    <div className='container-fluid' id='our-newsletter'>
      <div className="row">
        <div className="col col-5">
            <img src="img-data/about-page/news-letter-1.jpg" alt="" />
        </div>
        <hr />
        <div className="col col-5">
        <img src="img-data/about-page/news-letter-2.jpg" alt="" />
        </div>
        <hr />
        <div className="col col-5">
        <img src="img-data/about-page/news-letter-3.jpg" alt="" />
        </div>
        
      </div>
    </div>
  )
}

export default OurNewsLetter
